import { render, staticRenderFns } from "./ImageAsset.vue?vue&type=template&id=5443f641&"
import script from "./ImageAsset.vue?vue&type=script&lang=js&"
export * from "./ImageAsset.vue?vue&type=script&lang=js&"
import style0 from "./ImageAsset.vue?vue&type=style&index=0&id=5443f641&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports